import { render, staticRenderFns } from "./MaterialTemplateEditPage.vue?vue&type=template&id=44dadb31&scoped=true"
import script from "./MaterialTemplateEditPage.vue?vue&type=script&lang=ts"
export * from "./MaterialTemplateEditPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialTemplateEditPage.vue?vue&type=style&index=0&id=44dadb31&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dadb31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44dadb31')) {
      api.createRecord('44dadb31', component.options)
    } else {
      api.reload('44dadb31', component.options)
    }
    module.hot.accept("./MaterialTemplateEditPage.vue?vue&type=template&id=44dadb31&scoped=true", function () {
      api.rerender('44dadb31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/MaterialTemplateEditPage.vue"
export default component.exports